<div class="displayNameDialog">
    <sync-dialog 
    [config]="
    {
      title: 'Change name', 
      isClosable: false, 
      actionButton: 'Save', 
      cancelButton: 'Cancel',
      onActionClick: saveName,
      onCancelClick: closeNameDialog,
      isButtonLoading: isSaveButtonLoading,
      isActionButtonDisabled: nameLengthError.length > 0,
    }"
    [open]="showNameDialog" 
    [isFullScreen]="false"
    [onClose]="closeNameDialog">
    <div class="name-container">
        <app-error [errcode]="errcode"></app-error>
        <sync-text-field [label]="'Name'" [inputChange]="getDisplayName" [value]="displayName" [errorMessage]="nameLengthError"></sync-text-field>
     </div>
    </sync-dialog>
  </div>